<template>
  <div class="task-overview-settings__tasks">
    <Loader v-if="isInitLoad" bg-color="#fff"></Loader>
    <template v-else>
      <div class="do-table__filters">
        <div class="do-table__filters__left">
          <DoFiltersFilter
            title="Personer"
            :tags="persons"
            :selectedTags="selectedPersons"
            :numberOfSelectedTagsToShow="1"
            @select="onSelectPerson"
            @clear="selectedPersons = []">
          </DoFiltersFilter>
          <DoFiltersFilter
            title="Grupper"
            :tags="tags"
            :selectedTags="selectedTags"
            :numberOfSelectedTagsToShow="1"
            @select="onSelectTags"
            @clear="selectedTags = []">
          </DoFiltersFilter>
          <DoFiltersFilter
            title="Briktyper"
            :tags="subjectTypes"
            :selectedTags="selectedTypes"
            :numberOfSelectedTagsToShow="1"
            @select="onSelectType"
            @clear="selectedTypes = []">
          </DoFiltersFilter>
          <DoFiltersFilter
            title="Fag/Opgaver"
            :tags="subjectNames"
            :selectedTags="selectedSubjectsNames"
            :numberOfSelectedTagsToShow="1"
            @select="onSelectSubject"
            @clear="selectedSubjectsNames = []">
          </DoFiltersFilter>
        </div>
        <div class="do-table__filters__add">
          <span>Viser {{ filteredSubjects.length }} af {{ subjects.length }}</span>
          <div class="do-dropdown" :class="{'do-dropdown--open': isDropdown}" v-on-clickaway="onClickAway">
            <button class="do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled"
                    v-if="selectedSubjects.length < 1"
                    content="Vælg brikker først"
                    v-tippy="{
                    placement: 'left',
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
                }">
              Tildel {{ !isSupplements ? 'kategori' : 'lønkode' }} til {{ selectedSubjects.length }} <span
              class="icon-arrow-down5"></span>
            </button>
            <button class="do-dropdown__toggler do-bttn do-bttn--submit" v-else
                    @click="setIsDropdown">
              Tildel {{ !isSupplements ? 'kategori' : 'lønkode' }} til {{ selectedSubjects.length }} <span
              class="icon-arrow-down5"></span>
            </button>
            <transition name="do-dropdown">
              <div class="do-dropdown__dropdown" v-if="isDropdown">
                <ul v-if="!isSupplements">
                  <li class="text-explainer" v-if="taskCategories.length === 0">Ingen kategorier oprettet</li>
                  <li v-for="(taskCategory, key) in taskCategories"
                      class="do-dropdown__dropdown__item" @click="setTasksCategory(taskCategory)">
                    <div class="do-dropdown__dropdown__item__name">
                      {{ taskCategory.name }}
                    </div>
                  </li>
                </ul>
                <ul v-if="isSupplements">
                  <li class="text-explainer" v-if="salaryCodes.length === 0">Ingen lønkoder oprettet</li>
                  <li v-for="(salaryCode, key) in salaryCodes"
                      class="do-dropdown__dropdown__item" @click="setTasksCategory(salaryCode)">
                    <div class="do-dropdown__dropdown__item__name">
                      {{ salaryCode.vSupplementTitle }}
                    </div>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="do-table-wrapper">
        <table class="do-table">
          <thead>
          <tr>
            <th class="do-table__toggle-all" @click="toggleAll">
              <template v-if="selectedSubjects.length === 0">
                {{ $t('vue2.tagging.select_all') }}
              </template>
              <template v-else>
                Fravælg
              </template>
            </th>
            <th @click="sortBy('subject.name')" class="pointer">Titel <span v-if="sortKey === 'subject.name'">{{
                sortIcon
              }}</span></th>
            <th v-if="!isSupplements" @click="sortBy('calendar.name')" class="pointer">Person <span
              v-if="sortKey === 'calendar.name'">{{ sortIcon }}</span>
            </th>
            <th @click="sortBy('subject.calendar.name')" class="pointer">Klasse / kalender <span
              v-if="sortKey === 'subject.calendar.name'" class="pointer">{{ sortIcon }}</span></th>
            <th @click="sortBy('v_type')" class="pointer">Briktype <span v-if="sortKey === 'v_type'">{{
                sortIcon
              }}</span>
            </th>
            <th v-if="isSupplements" @click="sortBy('calendar.name')" class="pointer">Person <span
              v-if="sortKey === 'calendar.name'">{{ sortIcon }}</span>
            </th>
            <th v-if="!isSupplements">Standard kategori</th>
            <th v-if="!isSupplements">Egen kategori</th>
            <th v-if="isSupplements">Lønkode</th>
          </tr>
          </thead>
          <tbody>
          <virtual-list :style="{ maxHeight: 80 + 'vh', overflowY: 'auto' }"
                        :estimate-size="40"
                        :keeps="40"
                        :data-key="'id'"
                        :data-sources="sortedSubjects"
                        :data-component="itemComponent"
                        :extra-props="{
                          selectedSubjectIds: selectedSubjectIds,
                              selectedSubjects: selectedSubjects,
                              taskCategories: taskCategories,
                              toggleSubject: toggleSubject,
                              updateSubjectTaskCategory: updateSubjectTaskCategory,
                              isSupplements: isSupplements,
                              salaryCodes: salaryCodes
                            }"
          />
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import docendo from '../../docendo'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import {mixin as clickaway} from 'vue-clickaway'
import virtualList from 'vue-virtual-scroll-list'
import TaskOverviewSettingsCategoriesTasksTask from './TaskOverviewSettingsCategoriesTasksTask.vue'
import Loader from '../common/Loader.vue'

const I18N = {
  subject: 'Fag',
  optional: 'Valgfag/Hold',
  supplemental: 'UUV',
  frame: 'Temavisning',
  break: 'Pause',
  resource: 'Ressource (synlig)',
  person_resource: 'Ressource (skjult)',
  other_tasks: 'Anden tid',
  other_stuff: 'Øvrig tid',
  available: 'Rådighedstime',
  person_resource_visible: 'Ressource (synlig)',
  club: 'SFO tid',
  additional_tasks: 'Øvrige opgaver',
  preparation: 'Forberedelse',
  with_kids: 'Tid med børn',
  without_kids: 'Tid uden børn',
  pool: 'Lokalpulje',
  absence: 'Fravær',
  _extra_time_at_start_of_day_: 'Ekstra tid for start på dag',
  reservation: 'Reservation'
}

export default {
  components: {Loader, DoFiltersFilter, virtualList, TaskOverviewSettingsCategoriesTasksTask},
  mixins: [clickaway],
  props: {
    schoolId: {},
    schoolYearId: {},
    subjects: {
      type: Array,
      default: () => []
    },
    taskCategories: {
      type: Array,
      default: () => []
    },
    allCalendarsInHash: {
      type: Object,
      default: () => {
      }
    },
    allUsersInHash: {
      type: Object,
      default: () => {
      }
    },
    tags: {
      type: Array,
      default: () => []
    },
    isSupplements: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInitLoad: true,
      itemComponent: TaskOverviewSettingsCategoriesTasksTask,
      selectedSubjects: [],
      isDropdown: false,
      isUpdating: false,
      selectedTags: [],
      selectedPersons: [],
      selectedSubjectsNames: [], // Valgte fag
      selectedTypes: [], // Valgte typer
      sortKey: '', // Holder den aktuelle sorteringskolonne
      sortDirection: 'asc' // Holder sorteringsretningen ('asc' eller 'desc')
    }
  },
  computed: {
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted || []
    },
    selectedSubjectIds () {
      return new Set(this.selectedSubjects.map(s => s.id))
    },
    sortIcon () {
      return this.sortDirection === 'asc' ? '▲' : '▼'
    },

    sortedSubjects () {
      return [...this.filteredSubjects].sort((a, b) => {
        if (!this.sortKey) return 0 // Hvis ingen sortering, returnér original rækkefølge

        const valueA = this.getNestedValue(a, this.sortKey)
        const valueB = this.getNestedValue(b, this.sortKey)

        if (typeof valueA === 'string' && typeof valueB === 'string') {
          return this.sortDirection === 'asc'
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA)
        }

        return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA
      })
    },
    // Unik liste over personer
    persons () {
      return [...new Set(this.subjects.map(subject => subject.calendar.name))]
    },

    // Unik liste over fag-navne
    subjectNames () {
      return [...new Set(this.subjects.map(subject => subject.subject.name))]
    },

    // Unik liste over fag-typer
    subjectTypes () {
      return [...new Set(this.subjects.map(subject => {
        return this.getSubjectTypeLabel(subject.subject.subject_type)
      }))]
    },

    subjectsWithType () {
      return this.subjects.map(subject => {
        return {
          ...subject,
          v_type: this.getSubjectTypeLabel(subject.subject.subject_type),
          v_DefaultCategory: this.getDefaultTaskCategory(subject),
          v_tags: this.getTags(subject)
        }
      })
    },

    // **Hovedfiltrering - tager højde for valgte personer, fag og typer**
    filteredSubjects () {
      return this.subjectsWithType.filter(subject => {
        const matchesPerson = this.selectedPersons.length === 0 || this.selectedPersons.includes(subject.calendar.name)
        const matchesSubjectName = this.selectedSubjectsNames.length === 0 || this.selectedSubjectsNames.includes(subject.subject.name)
        const matchesType = this.selectedTypes.length === 0 || this.selectedTypes.includes(subject.v_type)
        const matchesTags = this.selectedTags.length === 0 || subject.v_tags.some(tag => this.selectedTags.includes(tag))

        return matchesPerson && matchesSubjectName && matchesType && matchesTags
      })
    }
  },
  methods: {
    getSubjectTypeLabel (subjectType) {
      if (subjectType === 'pool') {
        return this.localPoolTitle
      }
      const i18n = I18N[subjectType]
      return i18n || subjectType
    },
    getTags (subject) {
      if (!subject.calendar || !subject.calendar.user_id) {
        return []
      }
      const user = this.allUsersInHash[subject.calendar.user_id]
      return user && user.user_tags ? user.user_tags : []
    },
    getDefaultTaskCategory (subject) {
      return this.taskCategories.find(taskCat => taskCat.id === subject.default_task_category_id)
    },

    sortBy (column) {
      if (this.sortKey === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = column
        this.sortDirection = 'asc'
      }
    },

    getNestedValue (obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj) || ''
    },

    onSelectPerson (person) {
      this.toggleSelection(this.selectedPersons, person)
    },

    onSelectTags (tag) {
      this.toggleSelection(this.selectedTags, tag)
    },

    onSelectSubject (subjectName) {
      this.toggleSelection(this.selectedSubjectsNames, subjectName)
    },

    onSelectType (type) {
      this.toggleSelection(this.selectedTypes, type)
    },

    toggleSelection (array, value) {
      const idx = array.indexOf(value)
      if (idx < 0) {
        array.push(value)
      } else {
        array.splice(idx, 1)
      }
    },

    updateSubjectTaskCategory (subject, value) {
      this.isUpdating = true
      if (!this.isSupplements) {
        const updates = [{id: subject.id, selected_task_category_id: value}]
        docendo.bulkUpdateSubjectCalendars(this.schoolId, this.schoolYearId, updates, success => {
          this.$emit('updateSubjects', updates)
          this.isUpdating = false
          this.closeDropdown(false)
        }, failure => {
          console.log('failure')
          this.isUpdating = false
          this.closeDropdown(false)
        })
      } else {
        let parsedValue = value === '' ? null : value
        const updates = [{
          id: subject.id,
          salary_code_id: parsedValue,
          salary_cost_center_id: subject.salary_cost_center_id || null
        }]
        docendo.bulkUpdateSubjectCalendarsSalary(this.schoolId, this.schoolYearId, updates, success => {
          this.$emit('updateSubjects', updates)
          this.isUpdating = false
          this.closeDropdown(false)
        }, failure => {
          console.log('failure')
          this.isUpdating = false
          this.closeDropdown(false)
        })
      }
    },
    setTasksCategory (taskCategory) {
      this.isUpdating = true
      if (this.isSupplements) {
        const updates = this.selectedSubjects.map(selectedSubject => {
          return {
            id: selectedSubject.id,
            salary_code_id: taskCategory.id,
            salary_cost_center_id: selectedSubject.salary_cost_center_id || null
          }
        })
        docendo.bulkUpdateSubjectCalendarsSalary(this.schoolId, this.schoolYearId, updates, success => {
          this.$emit('updateSubjects', updates)
          this.isUpdating = false
          this.closeDropdown(false)
        }, failure => {
          console.log('failure')
          this.isUpdating = false
          this.closeDropdown(false)
        })
      }
      if (!this.isSupplements) {
        const updates = this.selectedSubjects.map(selectedSubject => {
          return {
            id: selectedSubject.id,
            selected_task_category_id: taskCategory.id
          }
        })
        docendo.bulkUpdateSubjectCalendars(this.schoolId, this.schoolYearId, updates, success => {
          this.$emit('updateSubjects', updates)
          this.isUpdating = false
          this.closeDropdown(false)
        }, failure => {
          console.log('failure')
          this.isUpdating = false
          this.closeDropdown(false)
        })
      }
    },
    onClickAway () {
      if (!this.isDropdown) return
      this.selectedSubjects = []
      this.isDropdown = false
    },

    closeDropdown () {
      this.isDropdown = false
      this.selectedSubjects = []
    },

    setIsDropdown () {
      this.isDropdown = !this.isDropdown
    },

    toggleAll () {
      if (this.selectedSubjects.length > 0) {
        this.selectedSubjects = []
      } else {
        this.selectedSubjects = [...this.filteredSubjects]
      }
    },

    toggleSubject (subject) {
      const idx = this.selectedSubjects.findIndex(selectedSubjects => selectedSubjects.id === subject.id)
      if (idx < 0) {
        this.selectedSubjects.push(subject)
      } else {
        this.selectedSubjects.splice(idx, 1)
      }
    }
  },
  mounted () {
    if (this.isSupplements) {
      this.$store.dispatch('readSalaryCodes')
    }
    setTimeout(_ => {
      this.isInitLoad = false
    }, 100)
  }
}

</script>

<style scoped>

.do-table__filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  border-bottom: 0;
  padding: 8px;
  border-radius: 4px 4px 0 0;
}

.do-table__filters__left {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.do-table__filters__add {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.do-table__filters__add span {
  font-style: italic;
  font-size: 11px;
  white-space: nowrap;
}

.do-table thead th:first-child {
  cursor: pointer;
}

.do-table__toggle-all {
  color: #468ad7;
  font-weight: 700;
  text-transform: initial;
  user-select: none;
}

.do-table__toggle-all:hover {
  color: #3e4450;
}

.do-table thead th,
.do-table tbody td {
  padding: 0.5rem 0.5rem;
}

.do-table thead th:first-child,
.do-table tbody td:first-child {
  width: 58px;
}

.do-table tbody {
  max-height: calc(100vh - 3rem - 36px - 51px - 1rem);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.do-table tbody tr td {
  cursor: pointer;
  border-left: 1px solid #e2e8f0;
}

.do-table tbody tr td:first-child:hover .d-checkbox {
  box-shadow: 0 0 1px 2px #468ad791;
}

.do-table tbody tr:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table .d-checkbox {
  margin-left: 16px;
}


.do-dropdown {
  position: relative;
}

.do-dropdown .do-dropdown__toggler {
  width: 200px;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  height: 34px;
  transition: transform .25s;
}

.do-dropdown .do-dropdown__toggler:active {
  transform: scale(0.98);
}

.do-dropdown__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 300px;
  background-color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0;
  min-width: 100px;
  user-select: none;
  border: 1px solid #6772e5;
  border-radius: 4px
}

.do-dropdown__dropdown ul {
  max-height: 70vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.do-dropdown__dropdown li {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.do-dropdown__dropdown ul li:first-child {
  border-radius: 4px 4px 0 0;
}

.do-dropdown__dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  min-height: 42px;
}

.do-dropdown__dropdown li:hover {
  background-color: #f6f9fc;
}

.do-dropdown__dropdown__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--border-color);
}

.do-dropdown__dropdown__item--active {
  background: #ccc;
  color: var(--primary);
  background-color: #f6f9fc;
}

.do-dropdown__dropdown__item--add {
  border-top: 1px solid var(--border-color);
  padding: 1rem;
}

.do-dropdown__dropdown__item .btn-trans {
  font-weight: normal;
  width: 100%;
  font-size: 11px;
  transition: transform 0.25s;
}

.do-dropdown__dropdown__item .btn-trans:active {
  transform: scale(0.98);
}

.italic.font-small {
  color: #8898aa;
}

.do-dropdown__dropdown__item__actions {
  display: flex;
  align-items: center;
}

.do-dropdown__dropdown__item__actions span {
  font-style: normal;
}

/* Enter og leave-aktive styrer selve overgangen */
.do-dropdown-enter-active, .do-dropdown-leave-active {
  transition: transform 0.15s ease, opacity 0.15s ease;
}

/* Starttilstand for enter (dropdown vises) */
.do-dropdown-enter {
  opacity: 0;
  transform: scale(0.98); /* Lille skaleringsfald i starten */
}

/* Sluttilstand for enter */
.do-dropdown-enter-to {
  opacity: 1;
  transform: scale(1); /* Tilbage til normal størrelse */
}

/* Starttilstand for leave (dropdown skjules) */
.do-dropdown-leave-to {
  opacity: 0;
  transform: scale(0.98); /* Samme lille skaleringsfald ved lukning */
}

.do-dropdown__dropdown__item__name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.do-dropdown__dropdown__item span {
  font-style: normal;
}

.do-dropdown__dropdown__item__name + .icon__bg-circle {
  opacity: 0;
}

.do-dropdown__dropdown__item:hover .do-dropdown__dropdown__item__name + .icon__bg-circle {
  opacity: 1;
}

.do-table .do-select {
  width: 100%;
}

.do-table-wrapper {
  max-height: calc(100vh - 3rem - 36px - 51px - 1rem);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.do-table {
  width: 100%;
  border-collapse: collapse;
}

.do-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.do-table th, .do-table td {
  padding: 8px;
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// TaskOverviewSettingsCategoriesTasks.vue?918b5b5a